import { render, staticRenderFns } from "./tasksAccordionPanel.vue?vue&type=template&id=2c60dacd&"
import script from "./tasksAccordionPanel.vue?vue&type=script&lang=js&"
export * from "./tasksAccordionPanel.vue?vue&type=script&lang=js&"
import style0 from "./tasksAccordionPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
